import { render, staticRenderFns } from "./AppDemoSwiper.vue?vue&type=template&id=023d1418&scoped=true"
import script from "./AppDemoSwiper.vue?vue&type=script&lang=js"
export * from "./AppDemoSwiper.vue?vue&type=script&lang=js"
import style0 from "./AppDemoSwiper.vue?vue&type=style&index=0&id=023d1418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d1418",
  null
  
)

export default component.exports